 /* to make description, size, shipping from drawers to accordion   */


// document.addEventListener("click", function (e) {
//   const trigger = e.target.closest(".product-accordion__trigger");
//   if (!trigger) return;

//   const item = trigger.closest(".product-accordion__item");
//   const openItem = document.querySelector(".product-accordion__item.is-open");

//   if (openItem && openItem !== item) {
//     openItem.classList.remove("is-open");
//   }

//   item.classList.toggle("is-open");
// });




document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".tab-trigger");
  if (!trigger) return;

  e.preventDefault(); //  stops form submit
  e.stopPropagation();

  const tab = trigger.dataset.tab;
  const accordion = trigger.closest(".product-tabs");

  const allTriggers = accordion.querySelectorAll(".tab-trigger");
  const allPanels = accordion.querySelectorAll(".tab-panel");

  allTriggers.forEach(t => t.classList.remove("is-active"));
  allPanels.forEach(p => p.classList.remove("is-active"));

  trigger.classList.add("is-active");
  accordion.querySelector(`[data-panel="${tab}"]`).classList.add("is-active");
});
